{
	"title": "Partners Management",
	"description": "Listing and registration of customers and suppliers.",
	"pixKeyCopiedSuccess": "PIX key copied successfully!",
	"pixKeyCopyError": "Error copying PIX key",
	"name": "Name / Trade name",
	"customerName": "Name",
	"namePlaceholder": "Enter the trade name/shxort name",
	"customerNamePlaceholder": "Enter the name",
	"legalName": "Company name",
	"legalNamePlaceholder": "Enter legal name/full name",
	"cpfOrCnpj": "CPF/CNPJ",
	"cpfOrCnpjPlaceholder": "Enter the CPF/CNPJ",
	"inscricaoEstadual": "State registration",
	"inscricaoEstadualPlaceholder": "Enter the state registration",
	"cep": "Zip code",
	"cepPlaceholder": "Enter the zip code",
	"state": "State",
	"statePlaceholder": "Enter the state",
	"city": "City",
	"cityPlaceholder": "Enter the city",
	"street": "Address",
	"streetPlaceholder": "Enter the address",
	"streetNumber": "Number",
	"streetNumberPlaceholder": "Enter the number",
	"complemento": "Complement",
	"complementoPlaceholder": "Enter the complement",
	"neighborhood": "Neighborhood",
	"neighborhoodPlaceholder": "Enter the neighborhood",
	"bank": "Bank",
	"bankPlaceholder": "Enter the bank",
	"agency": "Agency",
	"agencyPlaceholder": "0000",
	"account": "Account",
	"accountPlaceholder": "Enter the account",
	"ownerName": "Owner name",
	"ownerNamePlaceholder": "Enter account owner",
	"bankcpfOrCnpj": "CPF/CNPJ",
	"bankcpfOrCnpjPlaceholder": "Enter the owner's CPF/CNPJ",
	"phone": "Landline",
	"cellPhone": "Cell phone",
	"email": "E-mail",
	"placeholderPhone": "(00) 0000-0000",
	"placeholderCellPhone": "(00) 0 0000-0000",
	"placeholderEmail": "example@email.com",
	"validateField": "Required field",
	"wishToAdd": "Do you wish to add?",
	"popConfirm": "Do you really want to delete this item?",
	"notInformed": "Not informed",
	"address": "Address",
	"actions": "Actions",
	"type": "Type",
	"addNewRegister": "Register partner",
	"editRegister": "Edit partner",
	"generalData": "General Data",
	"bankData": "Banking details",
	"bankAccount": "Bank account",
	"searchPlaceholder": "Search for customer, supplier, employee",
	"infoMessage": "The registration type is intended to parameterize the financial documents used by a customer, a supplier or both.",
	"registerTypes": {
		"client": "Customer",
		"supplier": "Supplier",
		"customerAndSupplier": "Customer and Supplier",
		"employee": "Employee"
	},
	"allPartners": "All partners",
	"selectRegistrationType": "Select the registration type",
	"modalWarningCancel": {
		"title": "Discard changes"
	},
	"confirmCancelRegistration": {
		"title": "Cancel registration",
		"message": "You are creating a partner registration. Are you sure you want to cancel?",
		"confirmText": "Continue registration",
		"cancelText": "Cancel"
	},
	"invalidAgency": "Invalid agency",
	"invalidAccount": "Invalid account",
	"invalidZipCode": "Invalid zip code",
	"invalidEmail": "Invalid e-mail",
	"supplierDetails": "Supplier details",
	"customerDetails": "Customer details",
	"employeeDetails": "Employee details",
	"customerAndSupplierDetails": "Customer and Supplier details",
	"viewDetails": "View details",
	"pixKeyType": "PIX Key Type",
	"pixKeyTypePlaceholder": "Select the type",
	"pixKey": "PIX Key",
	"pixKeyPlaceholder": "Enter the PIX key",
	"pixKeyTypes": {
		"cpf": "CPF",
		"cnpj": "CNPJ",
		"email": "Email",
		"phone": "Phone",
		"evp": "Random Key"
	},
	"pixKeyPlaceholders": {
		"cpf": "000.000.000-00",
		"cnpj": "00.000.000/0000-00",
		"email": "example@email.com",
		"phone": "(00) 00000-0000",
		"evp": "Random key (UUID)"
	},
	"errors": {
		"unknown": "Unknown error",
		"validationErrors": "Validation errors:",
		"clearFieldError": "Clear field error",
		"cpfInvalid": "Invalid CPF",
		"cnpjInvalid": "Invalid CNPJ",
		"cpfMustHaveDigits": "CPF must have 11 digits",
		"cnpjMustHaveDigits": "CNPJ must have 14 digits",
		"emailInvalid": "Invalid e-mail",
		"phoneMustHaveDigits": "Phone must have 10 or 11 digits",
		"randomKeyInvalidChars": "PIX key must contain only numbers, letters and hyphens",
		"randomKeyInvalidLength": "Random PIX key must have the correct 36-character format",
		"randomKeyInvalidFormat": "Invalid PIX key. Please check if you copied it correctly from your bank"
	},
	"fieldNames": {
		"id": "ID",
		"name": "Name",
		"legalName": "Legal Name",
		"inscricaoEstadual": "State Registration",
		"cpfOrCnpj": "CPF/CNPJ",
		"street": "Street",
		"streetNumber": "Number",
		"complemento": "Complement",
		"cep": "ZIP Code",
		"state": "State",
		"city": "City",
		"neighborhood": "Neighborhood",
		"bank": "Bank",
		"agency": "Agency",
		"account": "Account",
		"bankcpfOrCnpj": "CPF/CNPJ",
		"ownerName": "Owner Name",
		"phone": "Phone",
		"email": "Email",
		"cellPhone": "Cell Phone",
		"registerType": "Register Type",
		"pixKeyType": "PIX Key Type",
		"pixKey": "PIX Key"
	},
	"messages": {
		"pixKeyCopiedSuccess": "PIX key copied successfully!",
		"pixKeyCopyError": "Error copying PIX key"
	},
	"labels": {
		"pixKeyTypeUppercase": "PIX KEY TYPE",
		"pixKeyUppercase": "PIX KEY",
		"cpfCnpjUppercase": "CPF/CNPJ",
		"copyPixKey": "Copy PIX key"
	},
	"form": {
		"contactAndAddressSubtitle": "Contact and address information",
		"saving": "Saving...",
		"maxAttemptsReached": "Maximum attempts reached ({current}/{max})",
		"waitCooldown": "Wait {seconds}s",
		"reset": "Reset",
		"submissionBlockedTooltip": "Submission blocked - Attempts: {current}/{max}",
		"cooldownTooltip": "Cooldown: {seconds}s"
	}
}
